import React from "react";
const Adsense = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "19", height: "24", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("g", { fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M17.764 0c.277 0 .5.224.5.5 0 .075-.016.149-.049.216l-2.767 5.767L8.702 20.99 8.7 20.99l-.199.431c-.163.354-.518.58-.907.58H.5c-.276 0-.5-.224-.5-.5 0-.078.018-.154.053-.224l1.593-3.187L7.618 5.283l-.04.028L9.768.58c.163-.354.518-.58.907-.58h7.09zM20.848 11c.276 0 .5.224.5.5 0 .076-.017.15-.05.218l-1.505 3.099-2.814 6.034-.262.57c-.164.353-.518.579-.907.579h-4.687v-.001L9.691 22l1.644-3.469L14.845 11h6.003z",
    transform: "translate(1 1)"
  }
)));
var Adsense_default = Adsense;
export {
  Adsense_default as default
};
//# sourceMappingURL=Adsense.js.map
